import './MptcfeLib.js'
import '../less/main_article.less'
import 'mptcfe-spm/dist/js/index.js';
import Util from '../_utils/util.js'
import plugin from "./plugin"
import Cookie from 'js-cookie'
import goSpecialUrl from '../_utils/go-special-url'
import API from './api';
import Exposure from '../_utils/exposure.js';
import Support from '../_utils/supporter.js';
import {
    articleEndAd,
    bottomBannerAd,
    middleBannerAd,
    middleInsertAd,
    middleTextAd,
    topBannerAd,
} from "@/ad/pages/articleAd.js";
import SohuStat from '../statistics/sohu-stat.js';
import PromEvStat from '../statistics/prom-ev-stat.js';
import AdPluginStat from '../statistics/ad-plugin-stat.js';
import Helper from '../_utils/helper.js';
import TransUtil from '../_utils/trans_utils.js';
import EventHelper from '../_utils/eventHelper.js';
import { initSohuTv, resetQQTv } from './plugin/article_common.js'
import CallAppComp from '../components/CallApp/CallApp'
import { initImgLazyload, initLastImgLazyload } from '../_utils/article-images-lazyload'
import CallApp from '../components/CallSohunews'
import axios from 'axios'
import loadVconsole from '../_utils/vconsole.js'
import { getUserInfo } from './article-main/request/api'
import { imgBindClickEvent } from '../_utils/article-images-show'
import renderBlock from './article-main/handleDom'
// 对finally进行低版本兼容
import prototypeFinally from 'promise.prototype.finally';
prototypeFinally.shim()
// app增流上报questMobile请求
import questMobile from '../_utils/questMobile';
// import { initSentry } from '@/_utils/initSentry'

window.goSpecialUrl = goSpecialUrl;
window.EVENT_BUS = Util.eventBus
const MptcfeUtils = window.MptcfeUtils
const PerformanceUtil = MptcfeUtils.PerformanceUtil
window.axios = axios
/**
 * @description 是否展示查看更多，目前的条件是：1、在百度APP内 2、百度搜索来源
 */
const isShowLookAll = !Support.isBaiduboxapp


const article = function (cfg) {
    // initSentry() // 初始化sentry
    //渠道码‘060005_xxhd’：线下活动
    const isfromXXHD = Helper.isUrlParamExist('_trans_', '060005_xxhd');
    //渠道码000018_sqkd_kd: 腾讯小程序
    const isFromQZone = Helper.isUrlParamExist('_trans_', '000018_sqkd_kd');
    //是否来自党专区，用c码标记，因为_f码统计逻辑已去除
    const isFromDangNews = window.location.href.indexOf('d-news') > 0 || window.location.href.indexOf('hot-news') > 0;
    /**
     * 文章页级别
     * 1 S- 除信息流广告以外其余都屏蔽，同时屏蔽标签以及自营推广位
     * 2 S  屏蔽所有广告和推广位
     * 3 S+ 屏蔽所有广告和推广位
     */
    const isFromSgrade1 = window.cfgs.Sgrade == 1
    const isFromSgrade2 = window.cfgs.Sgrade == 2
    const isFromSgrade3 = window.cfgs.Sgrade == 3

    // 来自于两会专题页的文章都按照s级别进行处理
    const isFromSubject = document.referrer && (document.referrer.indexOf('subject/325660') > -1)
    if (isFromSubject) {
        isFromSgrade2 = true
    }

    //链接中是否包含g=0参数，用来赋予运营屏蔽中插广告的权限
    const isGEqualZero = window.location.href.indexOf('g=0') > 0;
    // 政务账号转载文章风险处理，用来赋予屏蔽中插广告的权限。模版数据返回存在osdName
    const existOSD = window.cfgs.existOSD
    //是否在手搜APP内
    const isMSOHU = Support.isMSOHU;

    // channelId是文章的属性之一
    const isFromNewsChannel = cfgs && cfgs.channelId == 8;
    //是否禁止所有位置的广告：手搜App内和线下活动渠道屏蔽所有广告
    const isForbiddenAllAd = isMSOHU || isfromXXHD || isFromSgrade1 || isFromSgrade2 || isFromSgrade3;
    //是否禁止中插广告：党专区、g=0等情况，屏蔽中插广告
    const isForbiddenMiddleAd = isFromDangNews || isGEqualZero || existOSD || isFromSgrade1 || isFromQZone;
    // 是否禁止底部广告
    const isForbiddenBottomAd = isFromDangNews || isFromSgrade2 || isFromSgrade3;
    // 是否禁止所有推广位
    const isForbiddenPromotion = isFromSgrade1 || isFromSgrade2 || isFromSgrade3;
    window.isForbiddenPromotion = isForbiddenPromotion
    // 禁止中通广告
    const isForbiddenMiddlePassAd = isFromSgrade1;
    //是否禁止中部文字链广告
    const isForbiddenMiddleTextAd = isFromSgrade1;
    // 文章等级为S+，S 文章不折叠
    const isNoFold = isFromSgrade2 || isFromSgrade3

    // 加载vconsole
    loadVconsole()
    renderBlock.rendertopHeader() // 顶部导航栏组件
    initImgLazyload() // 图片懒加载解密
    imgBindClickEvent() // 为图片绑定点击预览事件
    /**
     * @description 页面阅读时长统计上报
     */
    let _dispaly = false
    let _hasHiddenData = true
    let _height = document.documentElement.clientHeight
    let _firstRatio = (100 - Number(cfgs.hiddenRatio)) / 100
    let _readingRatio = 0
    if (_firstRatio === 1) {
        _dispaly = true
        _hasHiddenData = false
    }
    window.TIMETRACKER = new MptcfeUtils.TimeTracker()
    window.TIMETRACKER.setPageState(
        {
            "showRatio": `${100 - Number(cfgs.hiddenRatio)}%`,
        }
    )

    /**
     * @description 监听点击展开剩余更多成功的事件
     */
    Util.eventBus.$on('lookAllClick', () => {
        _dispaly = true

        setTimeout(() => {
            let _result = 0
            let _firstReadingHeight = _height + $(window).scrollTop() - $('.display-content')[0].offsetTop
            let _firstContenHeight = $('.display-content').outerHeight()

            if (_firstReadingHeight > _firstContenHeight) _firstReadingHeight = _firstContenHeight

            let _secondReadingHeight = _height + $(window).scrollTop() - $('.hidden-content')[0].offsetTop
            let _secondContenHeight = $('.hidden-content').outerHeight()

            if (_secondReadingHeight > _secondContenHeight) _secondReadingHeight = _secondContenHeight

            _result = (_firstReadingHeight + _secondReadingHeight) / (_firstContenHeight + _secondContenHeight)

            _readingRatio = _result
            window.TIMETRACKER.setPageState(
                {
                    "ratio": `${_readingRatio * 100}%`,
                }
            )

            window.TIMETRACKER.setPageState(
                {
                    "showRatio": "100%",
                }
            )
        }, 0)
    })

    MptcfeUtils.event.on("WINDOWSCROLL", () => {

        if (_readingRatio === 1) return

        let _result = 0

        if (_hasHiddenData === true && _dispaly === false) {
            let _firstReadingHeight = _height + $(window).scrollTop() - $('.display-content')[0].offsetTop
            let _firstContenHeight = $('.display-content').outerHeight()

            if (_firstReadingHeight > _firstContenHeight) _firstReadingHeight = _firstContenHeight

            _result = _firstReadingHeight / _firstContenHeight
        } else if (_hasHiddenData === true && _dispaly === true) {
            let _firstReadingHeight = _height + $(window).scrollTop() - $('.display-content')[0].offsetTop
            let _firstContenHeight = $('.display-content').outerHeight()

            if (_firstReadingHeight > _firstContenHeight) _firstReadingHeight = _firstContenHeight

            let _secondReadingHeight = _height + $(window).scrollTop() - $('.hidden-content')[0].offsetTop
            let _secondContenHeight = $('.hidden-content').outerHeight()

            if (_secondReadingHeight > _secondContenHeight) _secondReadingHeight = _secondContenHeight

            _result = (_firstReadingHeight + _secondReadingHeight) / (_firstContenHeight + _secondContenHeight)
        } else {
            let _firstReadingHeight = _height + $(window).scrollTop() - $('.display-content')[0].offsetTop
            let _firstContenHeight = $('.display-content').outerHeight()

            if (_firstReadingHeight > _firstContenHeight) _firstReadingHeight = _firstContenHeight

            _result = _firstReadingHeight / _firstContenHeight
        }

        /**
         * @description
         */
        if (_readingRatio < _result) _readingRatio = _result

        window.TIMETRACKER.setPageState(
            {
                "ratio": `${_readingRatio * 100}%`,
            }
        )
        if (_readingRatio === 1) window.TIMETRACKER.reportPageState()
    })

    //文章页的中部通栏广告
    if (!isForbiddenAllAd && !isForbiddenMiddlePassAd) {
        middleBannerAd()
    }

    // 文章页中插广告逻辑
    if (!isForbiddenAllAd && !isForbiddenMiddleAd) {
        if (isFromNewsChannel) {
            articleEndAd()
        } else {
            middleInsertAd()
        }
        // 顶通广告位请求
        topBannerAd()
    } else {
        // 当不展示顶部通栏广告时，去除占位区块
        var topBillWrapper = document.querySelector('.top-bill-wrapper')
        topBillWrapper && topBillWrapper.parentNode.removeChild(topBillWrapper)
    }

    //文章页底部广告逻辑
    if (!isForbiddenAllAd && !isForbiddenBottomAd) {
        bottomBannerAd()
    }

    //文章页中部文字链广告逻辑
    if (!isForbiddenAllAd && !isForbiddenMiddleTextAd) {
        middleTextAd()
    }

    //清理图片样式保证在移动端显示正常
    $("#articleContent img[style]").removeAttr("style");

    // 多余标签的处理，由于隐藏的会打码上报曝光，故做此逻辑
    let $tags = document.querySelectorAll('.article-tags-new .tag');
    if ($tags && $tags.length > 0) {
        let firstTagTop = $tags[0].getBoundingClientRect().top;
        for (let i = 0; i < $tags.length; i++) {
            if ($tags[i].getBoundingClientRect().top <= firstTagTop) {
                $tags[i].removeAttribute('data-spm-stop');
            }
        }
    }
    embed2iframe()
    AdPluginStat.init(); // 广告插件统计初始化
    // 依赖登录信息的区块渲染
    getUserInfo().then((res) => {
        console.log('获取用户信息成功', res)
        if (res?.code == 1 && res?.data) {
            window.userInfo = res?.data
        }
    }).catch((error) => {
        console.log('获取用户信息失败', error)
    }).finally(() => {
        renderBlock.renderArticleInsertLogic() // 文章页插入功能卡
        renderBlock.renderCommentFooter() // 底部评论
    })

    renderBlock.renderShare() // 分享
    renderBlock.renderFollowAuthor() // 订阅作者
    renderBlock.renderChannelEntry() // 频道集合入口
    renderBlock.renderRecommend() // 相关推荐
    renderBlock.renderToastDialog()
    renderBlock.renderBackTop() // 回到顶部
    renderBlock.renderRecommendSearch() // 推荐搜索
    renderBlock.renderTransferArticle() // 转载文章声明
    renderBlock.renderNavMap() // 底部网站地图 s+与s级别不展示
    renderBlock.renderFooterMenu() // 底部版权申明
    renderBlock.renderNewStatement() // 底部标签 && 声明
    renderBlock.renderFooterMenu() // 底部版权申明
    renderBlock.renderArticleOrigin() // 文章来源标识
    renderBlock.showBannedNotice() //  禁言封禁通知
    renderBlock.renderInteration() // 互动组件
    CallApp.callSohunews(cfg); // 判断展示唤起搜狐新闻标识（https://www.tapd.cn/69435443/markdown_wikis/show/#1169435443001013566）
    initSohuTv();
    resetQQTv();
    limitArticleShow(); //节流显示文章
    registerLogin();
    registerBindPhone();
    const exposure = new Exposure();// 曝光相关
    exposure.addListener();
    exposure.allExposureCheck();
    handleExposure()
    promotionExposure()

    // 针对百度来源，添加百度官方号ID声明
    if (document.referrer.indexOf('baidu.com') >= 0) {
        Helper.insertScript('//msite.baidu.com/sdk/c.js?appid=1576035302470711', true);
    }

    // 在轻APP中隐藏所有唤起客户端的元素
    if (Support.isMSOHU) {
        $("#followMedia, .c-call-client, .share-btn.icon-share").hide();
    }

    var isFirstScroll = true;
    // 文章页首次滑动曝光
    $(window).on('scroll', Util.throttle(function (e) {
        if (isFirstScroll) {
            window.sohuSpm?.sendAction({acode: 3403});
            isFirstScroll = false;
        }
    }, 500));

    //添加前端性能上报
    window.onload = () => {
        let opts = {
            mainJs: {
                reg: /\/main-.+\.js/g,
                type: 'js',
                name: 'jsn',
                duration: 'jsd',
            },
            mainCss: {
                reg: /\/main-.+\.css/g,
                type: 'css',
                name: 'cssn',
                duration: 'cssd',
            }
        }
        let performanceReportConfig = PerformanceUtil.performanceReportConfig
        let performanceReport = PerformanceUtil.performanceReport

        for (let i in performanceReportConfig) {
            performanceReport(performanceReportConfig[i], i, opts)
        }
        // 为APP增流的上报
        questMobile()
    }

    function limitArticleShow() {
        const $lookAll = document.querySelector('#artLookAll');
        if ($lookAll) {
            // 点击展开剩余后的处理函数
            function clickHandler() {
                Util.eventBus.$emit('lookAllClick') // 弹出点击展开剩余的事件
                document.querySelector('#articleContent .hide')?.classList?.remove('hide');
                initLastImgLazyload() // 解密展开更多的首屏图片懒加载
                document.querySelector('.lookall-box')?.classList?.add('hide')

                // 中插广告悬浮效果
                if (TransUtil.isTransPort('xm') && document.querySelectorAll('.middle-insert-ad') && document.querySelectorAll('.middle-insert-ad').length > 0) {
                    let opts = {
                        el: '.middle-insert-ad',              // 广告元素
                        contentEl: '#articleContent',         // 正文元素
                        insertLocation: '.statement',         // 插入到声明之后
                        timeout: 100,                         // 滚动事件触发时间间隔
                        promotion: '.promotion',
                    };
                    new ScrollFixInsert(opts)
                }
            }
            // 在没有展开剩余按钮的情况下，模拟展开剩余的效果，这是必要的
            if (isShowLookAll === false || isNoFold) {
                clickHandler()
            }
            $lookAll.addEventListener('click', function () {
                if (CallAppComp.isAbleCallApp) {
                    CallAppComp.CallApp(
                        `sohunews://pr/news://newsId=${cfg.clientNewsId}&forwardurl=audioplay%3A%2F%2Fvolume%3D30%26tipsMsg%3D%26playStatus%3D0%26playLoc%3D`,
                        () => {
                            clickHandler()
                        },
                    )
                } else {
                    clickHandler()
                }
            })
        }
    }

    // 广告插件embed替换iframe
    function embed2iframe() {
        var adEmbedList = document.querySelectorAll('#articleContent embed[data-plugin]');
        [].slice.call(adEmbedList).forEach(function (adEmbed) {
            var parent = adEmbed.parentNode;
            var sid = adEmbed.getAttribute('data-sid');
            var eid = adEmbed.getAttribute('data-eid');
            // 替换成相对协议
            var reg = /^http:/;
            var url = adEmbed.getAttribute('data-url').replace(reg, '');
            var appid = adEmbed.getAttribute('data-appid');
            var adP = document.createElement('p');
            // 新建iframe替换embed标签
            var adIframe = document.createElement('iframe');
            adIframe.src = url;
            adIframe.setAttribute('data-appid', appid);
            adIframe.setAttribute('data-eid', eid);
            adIframe.setAttribute('data-sid', sid);
            if (parent.nodeName === 'P') {
                // embed的父是p标签时，不包裹
                parent.replaceChild(adIframe, adEmbed);
            } else {
                // 用p标签包裹iframe
                adP.appendChild(adIframe);
                parent.replaceChild(adP, adEmbed);
            }
        })
    }

    function registerLogin() {
        API.register("show_login", function (params, cal) {
            let url = `https://m.passport.sohu.com/app/login?appid=116001&r=${encodeURIComponent(params.from)}`;
            window.location.href = url;
            if (typeof cal === 'function') cal();
        });
    }

    function registerBindPhone() {
        API.register("show_bind_phone", function (params, cal) {
            let url = `https://m.passport.sohu.com/app/quickBindPhone?appid=116001&r=${encodeURIComponent(params.from)}`;
            window.location.href = url;
            if (typeof cal === 'function') cal();
        })
    }

    function handleExposure() {
        // 推广位曝光统计
        PromEvStat.init();
        // “展开更多”曝光
        if (document.querySelector('#artLookAll')) {
            exposure.add({
                dom: document.querySelector('#artLookAll'),
                callback: function () {
                    SohuStat.sendActionStat('10120023');
                }
            });
        }
        // 网站地图曝光
        exposure.add({
            dom: document.querySelector('.footer-navs-wrapper'),
            callback: function () {
                SohuStat.sendActionStat('10120021');
            }
        });

        // 浏览到文章正文末尾
        const articleEnd = document.querySelector('#articleContent footer.footer-tag-state');
        exposure.add({
            dom: articleEnd,
            callback: function () {
                // 埋点-正文末尾
                window?.sohuSpm?.sendAction({ acode: 3405 });
            }
        });
    }

    //文章末尾用户推广位统计
    function promotionExposure() {
        const promotionDom = document.querySelector('#articleContent section.promotion a');
        if (!promotionDom) {
            return;
        }
        const uuid = promotionDom.getAttribute('data-uuid');
        const promotionLink = promotionDom.getAttribute('data-link');
        // 自媒体推广
        if (uuid) {
            exposure.add({
                dom: promotionDom,
                callback: function () {
                    SohuStat.sendStatistics('appEv', {
                        'appId': 0,
                        'mediaId': cfg.media_id,
                        'newsId': cfg.newsId,
                        'lobId': '002'
                    });
                }
            });
        }
        // 通用曝光统计
        exposure.add({
            dom: promotionDom,
            callback: function () {
                SohuStat.sendActionStat(10120450, {
                    'contentUrl': encodeURIComponent(promotionLink)
                });
            }
        });

        EventHelper.addHandler(promotionDom, 'click', () => {
            if (uuid) {
                SohuStat.sendStatistics('appAction', {
                    'appId': 0,
                    'actionId': uuid,
                    'mediaId': cfg.media_id,
                    'newsId': cfg.newsId,
                    'lobId': '002'
                });
            }

            window.location.href = promotionLink;
        })
    }
};

var params = Util.parseURL(window.location.href);
if(params._trans_){
    Cookie.set('_trans_', params._trans_, { expires: 7 });
}

window.h5_sohu = {
    article
};
window.h5_sohu.plugin = plugin